import {StarRating} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_reviews.types';

export const starRatingMap: {[k in StarRating]: number} = {
  0: 0,
  1: 1,
  2: 1.5,
  3: 2,
  4: 2.5,
  5: 3,
  6: 3.5,
  7: 4,
  8: 4.5,
  9: 5,
};
